import {saveAs} from "file-saver";
import {Workbook} from "exceljs";

export const saveExcelFile = (workbook: Workbook, fileName: string) => {
    workbook.xlsx
        .writeBuffer()
        .then((buffer) =>
            saveAs(new Blob([buffer as any]), `${fileName}.xlsx`)
        )
        .catch((err) => {});
}